
import { useCallback, useState, useContext, useEffect } from "react";
import {
  addOrgAwardsAward,
} from "../MyProfile/Service/profileService";
import { getOrganizationDepartments,addOrganizationDepartments,deleteOrganizationDepartments } from "./Services/AdvanceSettingService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";

const OrgDepartmentCategory = () => {
  const [columns, setColumns] = useState(["Department", "Department Description"]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [orgDeptList,setOrgDeptList] = useState([]);
  const [selectedId, SetSelectedId] = useState();
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgDepartId, setOrgDepartId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    Department: "",
    DepartmentDescription: "",
  });

  useEffect(() => {
    GetOrgDepartments();
  }, []);

    const validateOrgDepart = (data, index) => { 
    const newErrors = {};
    newErrors[`${index}-Department`] =
      !data.Department || data.Department.trim() === ""
        ? "Department is required"
        : undefined;
    newErrors[`${index}-DepartmentDescription`] =
      !data.DepartmentDescription || data.DepartmentDescription.trim() === ""
        ? "DepartmentDescription is required"
        : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgDepartments() { 
    setIsloading(true);    
    try {
      let responce = await getOrganizationDepartments({});
      setOrgDeptList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgDeptList([
      ...orgDeptList,
      { Department: "", DepartmentDescription: ""},
    ]);
    setEditIndex(orgDeptList.length); 
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
  const { value } = e.target;
  setOrgDeptList(prevList => {
    const newList = prevList.map((item, idx) =>
      idx === rowIdx ? { ...item, [colName]: value } : item
    );
    return newList;
  });
  setData(prev => ({ ...prev, [colName]: value }));
  validateOrgDepart({ ...orgDeptList[rowIdx], [colName]: value }, rowIdx);
};

  const cancelOrgWfh = () => {
  GetOrgDepartments();
  setOrgDeptList(prevList => {
    setEditIndex(null);
    const len = prevList.length;
    if (len === 0) return prevList;
    const lastItem = prevList[len - 1];
    const isEmpty = lastItem &&
      !lastItem.Department &&
      !lastItem.DepartmentDescription ;
    if (isEmpty) {
      return prevList.slice(0, -1);
    }
    return prevList;
  });
}
  async function addOrgDepart(index, data) { 
  const body = {
  Id: data?.Id || 0,
  IsActive: true,
  OrgId: userDetails?.OrgId,
  Department: data.Department,
  DepartmentDescription: data.DepartmentDescription,
    };
    try {
      await addOrganizationDepartments(body);
      if (orgDepartId) {
        alert('Org Leave Updated');
      } else {
        alert('Org Leave Added');
      }
      SetSelectedId(null);
      setOrgDeptList([]);
      setEditIndex(null);
      GetOrgDepartments();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleDepartIstDelete = (Id) => {
    setOrgDepartId(Id);
  };

   async function DeleteOrgPolicy() { 
      setIsloading(true);
      if (orgDepartId) {
        let body = {
          Id: orgDepartId,
        };
        try {
          let orgDepartDeleteList = await deleteOrganizationDepartments(body);
          if (orgDepartDeleteList) {
            // GetMasterSystemAlertList("Award_Deleted", 0);
            setIsloading(false);
            GetOrgDepartments();
          }
        } catch (error) {
          toster.current.error(ERROR_LIST.DefaultError);
        }
      }
    }


  let SearchValue = "";
  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgDeptList.filter((orgDepart) =>
        orgDepart.Department?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgDeptList(filteredList);
      } else {
        GetOrgDepartments();
      }
    }, 800),
    [orgDeptList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Departments Types ({orgDeptList?.length})</h3>
          <div className="d-flex">
          <InputText
            name="requestTitle"
            className="form-control search-grpname me-2"
            onChange={handleInputChange}
            placeholder="Search"
          />
          {!editIndex && (
            <button
              className="addaward-btn"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-bs-original-title=""
              fdprocessedid="izng1j"
              onClick={handleAddRow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
              </svg>
              Departments
            </button>
          )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgDeptList?.map((data, index) => (
                <tr key={index}>                  
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={data.Department}
                          onChange={handleChange(index, "Department")}
                          placeholder="Department"
                          className={`form-control ${errors[`${index}-Department`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-Department`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Department`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          value={data.DepartmentDescription}
                          onChange={handleChange(index, "DepartmentDescription")}
                          placeholder="Department Description"
                          className={`form-control ${errors[`${index}-DepartmentDescription`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-DepartmentDescription`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-DepartmentDescription`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            onClick={() => {
                              if (validateOrgDepart(data, index)) {
                                addOrgDepart(index, data);
                              }
                            }}
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.Department}</td>
                      <td>{data?.DepartmentDescription}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>

                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-department"
                          onClick={() => {
                            handleDepartIstDelete(data?.Id);
                            // GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>






          </table>
        </div>






        <div className="modal fade " id="delete-org-department">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Departments?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgPolicy()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>




      </div>
    </div>
  );
};
export default OrgDepartmentCategory;